import CloseIcon from '@mui/icons-material/Close'
import { Grid, IconButton, styled } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

interface ModalProps {
  heading: string
  open: boolean
  Content: any
  setOpen: (open: boolean) => void
  minWidth?: string
  minHeight?: string
  maxHeight?: string
  maxWidth?: string
}

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[400]}`,
  padding: '1rem',
}))

const WindowPopUp = ({
  heading,
  open,
  setOpen,
  Content,
  minWidth,
  minHeight,
  maxHeight,
  maxWidth,
}: ModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        '& .MuiPaper-root': {
          minWidth: minWidth || '45vw',
          maxWidth: maxWidth || '60vw',
          minHeight: minHeight || '20vw',
          maxHeight: maxHeight || '45vw',
        },
      }}
    >
      <StyledDialogTitle>
        <Grid container justifyContent="space-between" alignItems="Center">
          <Grid item>{heading}</Grid>
          <Grid item>
            <IconButton aria-label="remove">
              <CloseIcon
                onClick={() => {
                  setOpen(false)
                }}
              />
            </IconButton>
          </Grid>
        </Grid>
      </StyledDialogTitle>

      <DialogContent style={{ padding: '1.5rem', height: '100%' }}>
        {Content}
      </DialogContent>
    </Dialog>
  )
}

export default WindowPopUp
